const performanceDashboard = {
  supplierSelector: {
    label: 'בחר צי:',
  },
};

export default performanceDashboard;